export default {
  general: 'Všeobecné',
  materialCalculationModels: 'Výpočtové modely materiálov',
  quenchingMediaSettings: 'Kaliacie médiá',
};
